export const ANSWERS = {
  GOOD: "GOOD",
  FAIL: "FAIL"
};



// WEBPACK FOOTER //
// ./src/game/constants.js